
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/composition",
      function () {
        return require("private-next-pages/material-ui/guides/composition.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/composition"])
      });
    }
  